const callVendorApi = (vendors, method, ...args) => {
  vendors.forEach(vendor => {
    if (vendor && vendor.api && typeof vendor.api[method] === 'function') {
      vendor.api[method](...args);
    }
  });
};

export default function createMetrics(config = {}) {
  const vendors = config.vendors || [];
  const getPageDefaults = typeof config.pageDefaults === 'function' ? config.pageDefaults : () => ({});
  let routeState = {};

  return {
    setRouteState(nextRouteState) {
      routeState = nextRouteState || {};
    },
    api: {
      pageView(params = {}) {
        callVendorApi(vendors, 'pageView', config.pageViewEvent || 'pageView', {
          ...getPageDefaults(),
          ...routeState,
          ...params,
        });
      },
      track(eventName, params = {}) {
        callVendorApi(vendors, 'track', eventName, {
          ...getPageDefaults(),
          ...routeState,
          ...params,
        });
      },
    },
  };
}